import React from "react";
import Button from "../../Button";
import "./style.css";

const CompA = () => {
  return (
    <div className="relative h-screen overflow-hidden flex pb-16 lg:pt-0 lg:flex-col lg:pb-0 w-full bg-[#FCFF78] home">
      <div className=" md:px-20 container-lg mx-auto">
        <img
          src="/Images/BagHome.svg"
          alt="bag"
          className=" w-[300px] md:w-[700px] object-cover absolute top-0 left-26 z-0 "
        />

        <div
          className="inset-y-0 top-0 right-0 z-0 w-full px-4 my-auto mx-auto md:px-0 lg:pr-0 lg:mb-0 lg:mx-0 lg:w-7/12 lg:max-w-full lg:absolute xl:px-0
          homeDisp"
        >
          <div className="mr-20">
            <img
              // className="object-cover w-full rounded lg:rounded-none lg:shadow-none lg:h-full px-10 absolute right-72 md:right-0"
              className=" absolute top-0 left-10 md:right-20 z-0  w-full rounded h-full  px-10"
              src="/Images/LadyHome.svg"
              alt="lady"
            />
          </div>
          <img
            src="/Images/RightBag.svg"
            className="absolute bottom-0 right-12 w-[400px] h-[250px] object-cover"
            alt="RightBag"
          />
        </div>
        {/* <div className="md:hidden">
          <img src="/Images/LadyHome.svg" alt="" className="absolute " />
        </div> */}
        <div className="relative mx-auto flex flex-col items-start justify-start w-full max-w-xl px-4 md:px-0 lg:px-8 lg:max-w-screen-xl mt-20 md:mt-0 z-20">
          <div className="mb-16 lg:my-40 lg:max-w-lg lg:pr-5">
            <h1 className="text-5xl lg:text-[60px] leading-none tracking-wider sm:text-center font-Jacques md:text-left font-bold">
              Shop near you <div className="pt-3">easily & on-time</div>
            </h1>
            <p className="text-[28px] leading-none md:text-2xl lg:text-3xl py-7 text-sm font-sans font-light sm:text-center md:text-left ">
              Variety of stores with unique and ordinary products just for you!
            </p>

            <div className="md:flex items-start">
              <span className="font-bold">
                <Button title={"Explore Products"} page={"product"} />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompA;
